<p-table
  [value]="duplicateFilingsEntryDetails"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedAggregateShares"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 25%">Filing Id</th>
      <th style="width: 25%">Issuer Name</th>
      <th style="width: 15%">Source Url</th>
      <th style="width: 33%">Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr [pSelectableRow]="share"
        [ngClass]="{
                  'row-duplicate': share.status === 'DUPLICATE',
                  'row-excluded': share.status === 'EXCLUDED'
                  }">
      <td>
        <a
          *ngIf="share.filingId; else empty"
          [href]="
            '/inbox?filingId=' +
            share.filingId +
            '&filingState=' +
            share.status
          "
          [style.color]="'#4a90e2'"
          [style.cursor]="'pointer'"
          [style.text-decoration]="'underline'"
          rel="noopener"
          target="_blank"
          >{{ share.filingId }}</a
        >

        <ng-template #empty>
          <span>-</span>
        </ng-template>
      </td>
      <td>{{ share.issuerName || "N/A" }}</td>
      <td>
        <a
          href="{{ share.sourceUrl }}"
          *ngIf="share.sourceUrl"
          target="_blank"
        >Link</a
        >

        <span *ngIf="!share.sourceUrl">-</span>
      </td>
      <td>
        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'EXCLUDED')"
          [disabled]="share.status === 'EXCLUDED'"
        >
          Exclude
        </button>
        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'DUPLICATE')"
          [disabled]="share.status === 'DUPLICATE'"
        >
          Duplicate
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="!isLoading && duplicateFilingsEntryDetails.length === 0">
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
